<template>
  <perfect-scrollbar id="users" class="content" v-on:click="configOpen = false">
    <div class="lthHeaderCnt">
      <div class="lBtn selectAll" v-if="1>2">
        <div class="theSelect"><div class="selectIn"></div></div>
      </div>
      <div class="lBtn refresh" v-on:click="getData"></div>
      <div class="tableTitle"></div>
      <div class="pagination">
        <div class="pageInfo">{{((page * limit) + 1).toLocaleString('id')}}-{{((page
          * limit) + results.length).toLocaleString('id')}} dari
          {{total.toLocaleString('id')}}</div>
        <div :class="{pageBtn: 1, pagePrev: 1, disabled: page === 0}"
          v-on:click="prevPage"></div>
        <div :class="{pageBtn: 1, pageNext: 1, disabled: ((page
          * limit) + results.length) >= total}"
          v-on:click="nextPage"></div>
        <div class="pageBtn config" :class="{open: configOpen}"
          v-on:click.stop="configOpen = !configOpen">
          <div class="ddCnt" v-if="configOpen" v-on:click.stop="doNothing">
            <div class="ddItem">
              <h4>Item Per Page</h4>
              <div class="radioCnt">
                <div class="radioItem" v-on:click="setItemPerPage(15)">
                  <div :class="{radio: 1, checked: limit === 15}"></div>
                  15 item per page
                </div>
                <div class="radioItem" v-on:click="setItemPerPage(25)">
                  <div :class="{radio: 1, checked: limit === 25}"></div>
                  25 item per page
                </div>
                <div class="radioItem" v-on:click="setItemPerPage(50)">
                  <div :class="{radio: 1, checked: limit === 50}"></div>
                  50 item per page
                </div>
                <div class="radioItem" v-on:click="setItemPerPage(100)">
                  <div :class="{radio: 1, checked: limit === 100}"></div>
                  100 item per page
                </div>
                <div class="radioItem" v-on:click="setItemPerPage(150)">
                  <div :class="{radio: 1, checked: limit === 150}"></div>
                  150 item per page
                </div>
                <div class="radioItem" v-on:click="setItemPerPage(250)">
                  <div :class="{radio: 1, checked: limit === 250}"></div>
                  250 item per page
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="listingCnt">
      <div class="listingItemCnt">
        <table>
          <tr>
            <th class="th1">Logs</th>
          </tr>
          <tbody v-if="loading">
            <tr>
              <td colspan="5" class="tdLoading">
                <SkAnimation :thumb="false" :tab="false" :header="false" type="user"/>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="(item, index) in results" :key="index">
              <td class="td1">
                <div :class="{profile: 1, log: true}"></div>
                {{item.message}}
                <p><timeago class="timestamp"
                  :datetime="item.timestamp * 1000"></timeago></p>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="tableInfo" v-if="!loading">
          Displaying {{limit.toLocaleString('id')}}
          of {{total.toLocaleString('id')}}
          items<br />&copy; {{$config.copyright}}. Powered by <a href="https://cmsriver.com"
          target="_blank">CMSRiver</a>
        </div>
      </div>
    </div>

    <Confirmation ref="confirmDialog"/>
    <Snackbar ref="snackbar"/>
    <AddUser ref="userDialog"/>
    <FormInputerShort ref="formInputer"/>
  </perfect-scrollbar>
</template>

<script>
import { mapActions } from 'vuex';
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';
import AddUser from '@/components/AddUser.vue';
import SkAnimation from '@/components/SkAnimation.vue';
import FormInputerShort from '@/components/FormInputerShort.vue';

export default {
  name: 'home',
  components: {
    Confirmation,
    Snackbar,
    AddUser,
    SkAnimation,
    FormInputerShort,
  },
  data() {
    return {
      limit: 15,
      page: 0,
      total: 0,
      loading: true,
      results: [],
      itemOpenedId: null,
      roles: [],
      loadingCost: true,
      currentCost: {
        totalPrice: 0,
        exchangeRates: 0,
        ratesDate: null,
      },
      configOpen: false,
    };
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB',
    ]),
    doNothing() {},
    leadingZeros(num, size) {
      let s = `${num}`;
      while (s.length < size) s = `0${s}`;
      return s;
    },
    setItemPerPage(itemPerPage) {
      this.configOpen = false;
      this.limit = itemPerPage;
      this.getData();
    },
    nextPage() {
      if (((this.page * this.limit) + this.results.length) >= this.total) return;
      this.page += 1;
      this.getData();
    },
    prevPage() {
      if (this.page === 0) return;
      this.page -= 1;
      this.getData();
    },
    getData() {
      this.loading = true;
      const uri = `undian/logs?limit=${this.limit}&page=${this.page}`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        this.loading = false;
        this.results = (r.data.status === 200) ? r.data.data : [];
        this.total = (r.data.status === 200) ? r.data.total : 0;
      });
    },
  },
  mounted() {
    this.chTitle('System Logs');
    this.chCGB(false);
    this.getData();
  },
};
</script>


<style scoped lang="scss">
  .currentBilling{
    border-bottom: #eee 1px solid;
    margin: 0 -30px;
    padding: 40px 30px;
    color: #555;
    h4{
      margin: 0 0 4px -3px;
      font-size: 40px;
    }
    p{
      font-size: 17px;
      margin: 0 0 10px;
    }
    .thePrice{
      font-weight: bold;
      font-size: 30px;
      margin: 0 0 4px;
    }
    .ratesInfo{
      font-size: 13px;
      color: #767676;
    }
  }
  .tableTitle{
    font-size: 19px;
    font-weight: 600;
  }
  .listingItemCnt{
    margin: 0 -30px;
  }
  .listingHeader{
    padding: 5px 20px;
    padding-left: 18px;
    .exportAll{
      float: right;
      background-color: #0057d8;
      font-size: 15px;
      margin-right: 10px;
      padding: 8px 16px;
      border-radius: 40px;
      transition: all .2s linear;
      color: #fff;
      cursor: pointer;
      img{
        height: 20px;
        margin-bottom: -4px;
        margin-right: 5px;
      }
    }
    .exportAll:hover{
      background-color: #0067ff;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    }
    .lhItem{
      font-size: 15px;
      float: left;
      margin-right: 10px;
      padding: 8px 16px;
      border-radius: 40px;
      opacity: .5;
      transition: all .2s linear;
      cursor: pointer;

      position: relative;
      padding-left: 62px;
      float: none;
      margin-right: 0;
      img{
        height: 20px;
        margin-bottom: -4px;
        margin-right: 5px;
      }
      .checkAll{
        width: 14px; height: 14px;
        border: #777 2px solid;
        border-radius: 4px;
        float: left;
        margin-right: 10px;
      }
    }
    .lhItem.rejectAll{
      opacity: 1;
      color: red;
    }
    .lhItem:before{
      content: "";
      position: absolute;
      left: 12px; top: -1px;
      width: 36px; height: 36px;
      background-color: #ccc;
      border-radius: 50%;
    }
    .lhItem:hover{
      // background-color: #eee;
      opacity: 1;
    }
  }
  table{
    border-collapse: collapse;
    width: 100%;
    tr{
      th{
        text-align: left;
        font-weight: bold;
        color: #999;
        padding: 10px 0;
        padding-left: 20px;
        border-bottom: #eee 1px solid;
        text-transform: uppercase;
      }
      th.th1{
        padding-left: 80px;
      }
      td{
        padding: 14px 0;
        padding-left: 20px;
        border-bottom: #eee 1px solid;
        position: relative;
        white-space: nowrap;
        &.tdLoading{
          padding: 0 30px;
          // border: none;
          &:hover{
            background-color: #fff;
          }
        }
        &.td1{
          padding-left: 80px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          max-width: 200px;
          font-weight: 600;
          p{
            margin: 2px 0 0;
            font-weight: normal;
            color: #767676;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .profile{
          left: 30px;
          top: 50%;
          margin-top: -18px;
          position: absolute;
          width: 36px;
          height: 36px;
          // background-image: url(../assets/user.png);
          background-color: #0e5dd2;
          background-size: 18px auto;
          background-position: center;
          background-repeat: no-repeat;
          border-radius: 7px;
          opacity: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          text-transform: uppercase;
          line-height: 1;
          &.wa{
            background-color: #4caf50;
            background-image: url(../assets/whatsapp-o-white.png);
          }
          &.sms{
            background-color: #f48604;
            background-image: url(../assets/sms-o-white.png);
          }
          &.log{
            background-color: #767676;
            background-image: url(../assets/log-format.png);
          }
        }
        .status{
          display: inline-block;
          color: #999;
          text-transform: uppercase;
          font-weight: 600;
          &.billed{
            color: #2771e0;
          }
          &.paid{
            color: #02b700;
          }
        }
        .action{
          position: absolute;
          right: 14px;
          top: 6px;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background-image: url(../assets/more.png);
          background-size: 18px auto;
          background-repeat: no-repeat;
          background-position: center;
          opacity: .4;
          cursor: pointer;
        }
        .action:hover{
          background-color: #ddd;
          opacity: .7;
        }
        .actionCnt{
          position: absolute;
          background: #fff;
          top: 40px;
          // border: 1px solid #ccc;
          box-shadow: 1px 1px 4px rgba(0,0,0,.2);
          border-radius: 10px;
          padding: 10px 0;
          white-space: nowrap;
          text-align: left;
          right: 14px;
          z-index: 4;
          margin-top: -5px;
          display: none;
          .divider{
            border-top: #eee 1px solid;
            padding-top: 4px;
            margin-top: 4px;
          }
          .actionItem{
            cursor: pointer;
            list-style: none;
            padding: 7px 42px;
            color: #444;
            font-size: 14px;
            min-width: 100px;
            img{
              height: 15px;
              margin: -4px 4px -2px -22px;
            }
          }
          .actionItem.actionRed{
            color: red;
          }
          .actionItem:hover{
            background-color: #eee;
          }
        }
        .actionCnt.open{
          display: block;
        }
        .actionOverlay{
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 3;
          display: none;
        }
        .actionOverlay.open{
          display: block;
        }
      }
      td.tdHeader{
        padding: 0;
      }
    }
    tbody{
      tr:hover{
        background-color: #f5f5f5;
        background-color: #f0f4ff;
        // cursor: pointer;
      }
    }
  }
</style>
